import { collection, doc, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const ImprovementPoint = async (
  department,
  topic,
  selectedOption,
  question
) => {
  try {
    const departmentRef = doc(db, "Departments", department);
    const topicRef = collection(departmentRef, "Topics");
    const querySnapshot = await getDocs(topicRef);

    const topicData = querySnapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .find((doc) => doc.topicName === topic);

    if (!topicData) return "No improvement suggestions available.";

    const questionsRef = collection(
      db,
      "Departments",
      department,
      "Topics",
      topicData.id,
      "Questions"
    );
    const questionSnapshot = await getDocs(questionsRef);

    const questionData = questionSnapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .find((q) => q.question === question);

    if (
      !questionData ||
      !Array.isArray(questionData.options) ||
      !Array.isArray(questionData.improvement_points)
    ) {
      return "No improvement suggestions available.";
    }

    const index = questionData.options.indexOf(selectedOption);
    return index !== -1
      ? questionData.improvement_points[index] || "No improvement needed."
      : "Selected option not found.";
  } catch (error) {
    console.error("Error fetching improvement suggestion:", error);
    return "Error retrieving improvement suggestions.";
  }
};
